module.exports = __webpack_public_path__ + "static/media/snowjob.3b8c37f6.mov";